import { memo, useCallback, useRef, useState } from "react";
import classNames from "classnames";
import { samePopperWidth } from "../../../utils";
import { Button, ButtonProps } from "../Button";
import { Dropdown } from "../Dropdown";

import styles from "./style.module.scss";

export type SplitButtonProps = ButtonProps & {
  label?: string,
}

export const SplitButton = memo<SplitButtonProps>((
  {
    className,
    children,
    label,
    ...props
  }) => {
  const [ isOpen, setIsOpen ] = useState(false);
  const refObject = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        type="button"
        buttonColorSchema="default"
        buttonType="secondary"
        className={classNames(className, styles.root, {
          [styles.openButton]: isOpen,
        })}
        ref={refObject}
        onClick={useCallback(() => setIsOpen(!isOpen), [ setIsOpen, isOpen ])}
        {...props}
      >
        <p className={styles.label}>{label}</p>
        <div className={styles.arrowBlock}>
          <div className={classNames(styles.arrow, {
            [styles.openArrow]: isOpen,
          })}>
          </div>
        </div>
      </Button>
      <Dropdown
        isOpen={isOpen}
        className={styles.dropdown}
        onRequestClose={useCallback(() => setIsOpen(false), [ setIsOpen ])}
        referenceElement={refObject?.current}
        popperOptions={{ modifiers: [ (samePopperWidth as any) ] }}
        closeOnWheel
      >
        {children}
      </Dropdown>
    </>
  );
});

export default SplitButton;
